<template>
  <article>
    <div class="grid gap-20 canvas-card__grid">
      <div class="canvas-card__content g-start-2 g-col-3 g-col-700-4 g-start-700-1 g-col-1000-5 g-start-1000-1">
        <h3 class="h4 canvas-card__title">
          <a class="pseudo-link no-underline canvas-card__link" :href="permalink" v-html="title">
          </a>
        </h3>
        <div class="meta-wrap canvas-card__meta-wrap" v-if="post_type.slug !== 'page' || post_type.template">
          <p class="m-0 meta-3" v-if="variation !== 'press-center'">
            {{ getCardTag() }}
          </p>
          <time class="meta-3" v-if="!post_type.template" :datetime="new Date(date).toISOString()">
            {{
              new Date(date)
                .toLocaleDateString("en-US", {
                  month: "short",
                  day: "2-digit",
                  year: "numeric",
                })
                .replace(",", "")
                .replace(/ /g, ".")
            }}
          </time>
        </div>
        <div v-if="subheadline" class="canvas-card__subheadline" v-html="subheadline"></div>
        <div class="canvas-card__arrow-wrap overflow-hidden">
          <svg class="canvas-card__arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none"
            aria-hidden="true">
            <path fill="#fff" fill-opacity=".01" d="M0 0h40v40H0z" />
            <path fill="#335E80"
              d="M20.174 2.5 37.13 19.134c.236.232.369.546.369.874 0 .328-.133.643-.37.875L20.19 37.5l-2.69-2.64 15.157-14.867L17.5 5.123 20.174 2.5Zm6.076 15.625v3.75H2.5c.32-.552.509-1.19.509-1.875 0-.684-.189-1.323-.509-1.875h23.75Z" />
          </svg>
        </div>
      </div>
      <div
        class="overflow-hidden rounded-16 g-col-1 g-start-1 g-col-700-3 g-start-700-6 g-col-1000-4 g-start-1000-7 image-hover__image-wrap canvas-card__image-wrap"
        :style="`--bg-image: url('${image.url}')`">
        <img class="cover image-hover__image canvas-card__image" :src="image.url" :alt="image.alt" loading="lazy" />
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "ContentListingBlockCard",
  props: {
    title: { type: String, required: true },
    subheadline: { type: String, required: false },
    permalink: { type: String, required: true },
    image: { type: Object, required: true },
    date: { type: String, required: true },
    post_type: { type: Object, required: true },
    primary_content_format: { type: String, required: false },
    variation: { type: String, required: true }
  },
  setup(props) {
    const permalink = props.permalink;

    // console.log(props.post_type);

    function openWindow(link) {
      window.open(link, "_self");
    }

    function getCardTag() {
      switch (props.post_type.slug) {
        case 'page':
          if (props.post_type.template !== 'product') {
            return;
          }

          return props.post_type.template;
        case 'insight':
          return props.primary_content_format || props.post_type.name;
        default:
          return props.post_type.name;
      }
    }

    return { permalink, openWindow, getCardTag };
  }
};
</script>